import type { GlobalThemeOverrides } from 'naive-ui'

/**
 * Naive UI 主题覆盖 — 映射 Design Token 到 Naive UI 主题变量
 * 确保 Naive UI 组件与管理面板亮色主题视觉一致
 */
export const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#2D7DFF',
    primaryColorHover: '#2D7DFF',
    primaryColorPressed: '#003DA6',
    primaryColorSuppl: '#6BB0FF',

    successColor: '#22C55E',
    warningColor: '#F59E0B',
    errorColor: '#EF4444',
    infoColor: '#3B82F6',

    textColorBase: '#1A1A1A',
    textColor1: '#1A1A1A',
    textColor2: '#434654',
    textColor3: '#6B7280',
    textColorDisabled: '#64748B',
    placeholderColor: '#94A3B8',
    placeholderColorDisabled: '#94A3B8',
    iconColorDisabled: '#94A3B8',

    borderColor: '#E5E7EB',
    dividerColor: '#F0F0F0',

    bodyColor: '#F8F9FB',
    cardColor: '#FFFFFF',
    modalColor: '#FFFFFF',
    popoverColor: '#FFFFFF',
    tableColor: '#FFFFFF',
    inputColor: '#FFFFFF',
    inputColorDisabled: '#F8FAFC',

    borderRadius: '6px',
    borderRadiusSmall: '4px',

    fontFamily:
      "'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
    fontSize: '14px',
    fontSizeMedium: '14px',
    fontSizeSmall: '13px',
    fontSizeLarge: '16px',
  },
  Button: {
    borderRadiusMedium: '8px',
    borderRadiusSmall: '6px',
    fontSizeTiny: '13px',
    fontSizeSmall: '13px',
    fontSizeMedium: '13px',
    fontSizeLarge: '13px',
  },
  Card: {
    borderRadius: '16px',
    paddingMedium: '20px',
    actionColor: '#FFFFFF',
  },
  DataTable: {
    borderRadius: '8px',
    fontSizeSmall: '13px',
    fontSizeMedium: '13px',
    fontSizeLarge: '13px',
    thColor: '#FFFFFF',
    tdColor: '#FFFFFF',
    thTextColor: '#7B8797',
    thFontWeight: '600',
    tdTextColor: '#1A1A1A',
    borderColor: '#F1F5F9',
    tdColorHover: '#FAFBFC',
    thColorHover: '#FFFFFF',
    borderColorModal: '#F1F5F9',
  },
  Input: {
    borderRadius: '8px',
    fontSizeTiny: '13px',
    fontSizeSmall: '13px',
    fontSizeMedium: '13px',
    fontSizeLarge: '13px',
    color: '#FFFFFF',
    colorDisabled: '#F8FAFC',
    colorFocus: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderDisabled: '1px solid #E2E8F0',
    borderFocus: '1px solid #0053DA',
    textColorDisabled: '#475569',
    placeholderColorDisabled: '#94A3B8',
  },
  Modal: {
    borderRadius: '16px',
  },
  Dialog: {
    // 二级确认弹窗沿用项目主色，避免 warning 类型及其 loading 禁用态回退为默认橙色。
    iconColorWarning: '#2D7DFF',
    peers: {
      Button: {
        colorWarning: '#2D7DFF',
        colorHoverWarning: '#2D7DFF',
        colorPressedWarning: '#003DA6',
        colorFocusWarning: '#2D7DFF',
        colorDisabledWarning: '#2D7DFF',
        textColorWarning: '#FFFFFF',
        textColorHoverWarning: '#FFFFFF',
        textColorPressedWarning: '#FFFFFF',
        textColorFocusWarning: '#FFFFFF',
        textColorDisabledWarning: '#FFFFFF',
        borderWarning: '1px solid #2D7DFF',
        borderHoverWarning: '1px solid #2D7DFF',
        borderPressedWarning: '1px solid #003DA6',
        borderFocusWarning: '1px solid #2D7DFF',
        borderDisabledWarning: '1px solid #2D7DFF',
      },
    },
  },
  Select: {
    peers: {
      InternalSelection: {
        borderRadius: '8px',
        fontSizeTiny: '13px',
        fontSizeSmall: '13px',
        fontSizeMedium: '13px',
        fontSizeLarge: '13px',
        color: '#FFFFFF',
        colorDisabled: '#F8FAFC',
        colorActive: '#FFFFFF',
        textColorDisabled: '#475569',
        placeholderColorDisabled: '#94A3B8',
        arrowColorDisabled: '#94A3B8',
      },
      InternalSelectMenu: {
        optionFontSizeTiny: '13px',
        optionFontSizeSmall: '13px',
        optionFontSizeMedium: '13px',
        optionFontSizeLarge: '13px',
        optionFontSizeHuge: '13px',
      },
    },
  },
  DatePicker: {
    itemFontSize: '13px',
    calendarDaysFontSize: '13px',
    calendarTitleFontSize: '13px',
    peers: {
      Input: {
        fontSizeTiny: '13px',
        fontSizeSmall: '13px',
        fontSizeMedium: '13px',
        fontSizeLarge: '13px',
      },
    },
  },
  Popconfirm: {
    iconSize: '20px',
    peers: {
      Popover: {
        padding: '12px',
      },
    },
  },
}
